/**
 * Converts a relative or absolute image URL to use the API upload route
 * This ensures proper CORS headers are set
 * @param url - The image URL (can be relative or absolute)
 * @returns The absolute URL using the API upload route
 */
export const getImageUrl = (url: string | undefined | null): string => {
    if (!url) return '';

    const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.crm.we4task.com';

    // Check if URL contains /uploads/ path (either relative or absolute)
    let uploadsPath = '';

    if (url.startsWith('http://') || url.startsWith('https://')) {
        // Absolute URL - extract the path after the domain
        try {
            const urlObj = new URL(url);
            const pathname = urlObj.pathname;

            // Check if pathname contains /uploads/
            if (pathname.includes('/uploads/')) {
                // Extract the part starting from /uploads/
                const uploadsIndex = pathname.indexOf('/uploads/');
                uploadsPath = pathname.substring(uploadsIndex);
            } else {
                // Not an uploads path, return as is
                return url;
            }
        } catch (e) {
            // Invalid URL, try to extract /uploads/ manually
            const uploadsIndex = url.indexOf('/uploads/');
            if (uploadsIndex !== -1) {
                uploadsPath = url.substring(uploadsIndex);
            } else {
                return url;
            }
        }
    } else if (url.startsWith('/uploads/')) {
        // Relative URL starting with /uploads/
        uploadsPath = url;
    } else if (url.includes('/uploads/')) {
        // URL contains /uploads/ but doesn't start with it
        const uploadsIndex = url.indexOf('/uploads/');
        uploadsPath = url.substring(uploadsIndex);
    } else {
        // Not an uploads path, return as is
        return url;
    }

    // Convert /uploads/folder/filename to /api/upload/folder/filename
    if (uploadsPath.startsWith('/uploads/')) {
        const pathWithoutUploads = uploadsPath.replace('/uploads/', '');
        const parts = pathWithoutUploads.split('/').filter(part => part.length > 0);

        if (parts.length >= 2) {
            const folder = parts[0];
            const filename = parts.slice(1).join('/');
            const convertedUrl = `${API_BASE_URL}/api/upload/${folder}/${filename}`;
            return convertedUrl;
        } else if (parts.length === 1) {
            // Edge case: /uploads/filename (no folder)
            return `${API_BASE_URL}/api/upload/general/${parts[0]}`;
        }
    }

    // Fallback - return original URL
    return url;
};

